import React, { useEffect, useState } from "react";
import TitlePageMenu from "../Components/TitlePageMenu";
import TitlePage from "../Components/TitlePage";
import HomeIcon from "@mui/icons-material/Home";
import ManageAccountsTwoToneIcon from "@mui/icons-material/ManageAccountsTwoTone";
import DataTable from "../Components/Table/DataTable";
import ContentPage from "../Components/ContentPage";
import { useDispatch, useSelector } from "react-redux";
import {
  list,
  usersCreate,
  usersDelete,
  usersUpdate,
} from "../store/Slice/usersSlice";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteSweepTwoToneIcon from "@mui/icons-material/DeleteSweepTwoTone";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useFormik } from "formik";
import { userGroupList } from "../store/Slice/userGroupSlice";
import { departmentDetailList } from "../store/Slice/departmentDetailSlice";
import { labFormList } from "../store/Slice/labFormSlice";
import * as Yup from "yup";
import Swal from "sweetalert2";
import ChipStatus from "../Components/ChipStatus";
import { useVisitDepartment } from "../features/LabStat/hooks/useVisitDepartment";

export default function UsersList() {
  const dispatch = useDispatch();
  const users = useSelector(({ users }) => users);
  const userGroup = useSelector(({ userGroup }) => userGroup);
  const departmentDetail = useSelector(
    ({ departmentDetail }) => departmentDetail
  );
  const labForm = useSelector(({ labForm }) => labForm);
  const { visitDepartmentName } = useVisitDepartment();

  const [search, setSearch] = useState({
    search: "",
    department_detail_id: "",
    permission_patient_type: "",
    lab_form_id: "",
    group_id: "",
  });

  useEffect(() => {
    dispatch(list());
    dispatch(userGroupList());
    dispatch(departmentDetailList());
    dispatch(labFormList());
  }, []);

  const onClickSearch = () => {
    dispatch(list(search));
  };

  const [valueTab, setValueTab] = React.useState(null);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
    setSearch({ ...search, group_id: newValue });
    dispatch(list({ group_id: newValue }));
  };
  const [open, setOpen] = React.useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      nameprefix: "",
      fname: "",
      lname: "",
      idcard: "",
      phone: "",
      email: "",
      addrpart: "",
      tmbpart: "",
      amppart: "",
      chwpart: "",
      zipcode: "",
      group_id: "",
      department_detail_id: "",
      lab_form_id: "",
      permission_patient_type: "",
      password: "",
      visit_department_detail_name: "",
    },
    validationSchema: Yup.object().shape({
      nameprefix: Yup.string().required("ระบุคำน้ำหน้า"),
      fname: Yup.string().required("ระบุชื่อ"),
      lname: Yup.string().required("ระบุนามสกุล"),
      idcard: Yup.string().required("ระบุ ID Card"),
      group_id: Yup.string().required("ระบุกลุ่มผู้ใช้งาน"),
    }),
    onSubmit: (values) => {
      // console.log(values);
      if (values.id) {
        dispatch(usersUpdate(values)).then(() => {
          dispatch(list());
          handleClose();
        });
      } else {
        dispatch(usersCreate(values)).then(() => {
          dispatch(list());
          handleClose();
        });
      }
    },
  });
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  const handleClickEdit = (data) => {
    console.log(data);
    formik.setFieldValue("id", data.id);
    formik.setFieldValue("nameprefix", data.nameprefix);
    formik.setFieldValue("fname", data.fname);
    formik.setFieldValue("lname", data.lname);
    formik.setFieldValue("idcard", data.idcard);
    formik.setFieldValue("phone", data.phone);
    formik.setFieldValue("lname", data.lname);
    formik.setFieldValue("email", data.email);
    formik.setFieldValue("addrpart", data.addrpart);
    formik.setFieldValue("tmbpart", data.tmbpart);
    formik.setFieldValue("amppart", data.amppart);
    formik.setFieldValue("chwpart", data.chwpart);
    formik.setFieldValue("zipcode", data.zipcode);
    formik.setFieldValue("group_id", data.group_id);
    formik.setFieldValue("department_detail_id", data.department_detail_id);
    formik.setFieldValue("lab_form_id", data.lab_form_id);
    formik.setFieldValue(
      "permission_patient_type",
      data.permission_patient_type
    );
    formik.setFieldValue(
      "visit_department_detail_name",
      data.visit_department_detail_name
    );
    handleClickOpen();
  };

  const rows = users.result;

  const columns = [
    {
      field: "#",
      headerName: "#",
      width: 30,
    },
    {
      field: "name",
      headerName: "ชื่อ - นามสกุล",
      renderCell: ({ row }) => {
        return (
          <Box>
            <Typography variant="body2">{row.name}</Typography>
            <Typography variant="caption" color={"gray"}>
              {row.email}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "idcard",
      headerName: "ID Card",
    },
    {
      field: "phone",
      headerName: "เบอร์โทร",
    },
    {
      field: "department_detail_name",
      headerName: "จุดตรวจ",
    },
    {
      field: "lab_form_name",
      headerName: "LAB Form",
    },
    {
      field: "permission_patient_type",
      headerName: "ประเภท",
    },
    {
      field: "group_name",
      headerName: "กลุ่มการใช้งาน",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <ChipStatus type={row.group_id} title={row.group_name} />
          </Box>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      numeric: "center",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              disabled={row.idcard === "admin"}
              startIcon={<EditTwoToneIcon />}
              sx={{ mr: 2 }}
              onClick={() => handleClickEdit(row)}
            >
              แก้ไข
            </Button>
            <Button
              variant="contained"
              startIcon={<DeleteSweepTwoToneIcon />}
              color="error"
              disabled={row.idcard === "admin"}
              onClick={() => {
                Swal.fire({
                  title: "คุณต้องการลบข้อมูลหรือไม่",
                  text: row.name,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#FF8C00",
                  cancelButtonColor: "#FF4500",
                  confirmButtonText: "ยืนยัน",
                  cancelButtonText: "ยกเลิก",
                  customClass: {
                    title: "sweetalert-title", // Apply Sarabun font to the title
                    content: "sweetalert-content", // Apply Sarabun font to the content
                    confirmButton: "sweetalert-confirm-button",
                    cancelButton: "sweetalert-cancel-button",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(usersDelete({ id: row.id })).then(() => {
                      dispatch(list());
                    });
                    Swal.fire({
                      title: "ลบ!",
                      text: "ลบข้อมูลเรียบร้อย",
                      icon: "success",
                    });
                  }
                });
              }}
            >
              ลบ
            </Button>
          </Box>
        );
      },
    },
  ];
  return (
    <Container maxWidth={"xl"}>
      <ContentPage
        image_icon={process.env.PUBLIC_URL + "/icons/medical-team.png"}
        title="ผู้ใช้งาน"
        TitlePageMenulist={[
          {
            label: "หน้าแรก",
            href: "/lab",
            icon: <HomeIcon fontSize="small" />,
          },
          {
            label: "Data Master",
            href: "#",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
          {
            label: "ผู้ใช้งาน",
            href: "/lab/users",
            icon: <ManageAccountsTwoToneIcon fontSize="small" />,
          },
        ]}
        btnAction={
          <Button
            variant="contained"
            startIcon={<AddCircleTwoToneIcon />}
            onClick={handleClickOpen}
          >
            เพิ่มผู้ใช้งาน
          </Button>
        }
      >
        <Paper elevation={0} sx={{ p: 1 }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
            mb={2}
          >
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="department_detail_id-label">จุดตรวจ</InputLabel>
                <Select
                  labelId="department_detail_id-label"
                  id="department_detail_id"
                  value={search.department_detail_id}
                  label="จุดตรวจ"
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      department_detail_id: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  {departmentDetail.result.map((opt, i) => (
                    <MenuItem key={i} value={opt.department_detail_id}>
                      {opt.department_detail_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="permission_patient_type-label">
                  ประเภท
                </InputLabel>
                <Select
                  labelId="permission_patient_type-label"
                  id="permission_patient_type"
                  value={search.permission_patient_type}
                  label="ประเภท"
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      permission_patient_type: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  <MenuItem value={"IPD"}>IPD</MenuItem>
                  <MenuItem value={"OPD"}>OPD</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={2}>
              <FormControl fullWidth size="small">
                <InputLabel id="lab_form_id-label">LAB Form</InputLabel>
                <Select
                  labelId="lab_form_id-label"
                  id="lab_form_id"
                  value={search.lab_form_id}
                  label="LAB Form"
                  onChange={(e) => {
                    setSearch({
                      ...search,
                      lab_form_id: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={""}>ทั้งหมด</MenuItem>
                  {labForm.result.map((opt, i) => (
                    <MenuItem key={i} value={opt.lab_form_id}>
                      {opt.lab_form_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={5}>
              <TextField
                fullWidth
                id="outlined-basic"
                type="search"
                value={search.search}
                label="ค้นหา"
                size="small"
                variant="outlined"
                onChange={(e) => {
                  setSearch({
                    ...search,
                    search: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <Button
                variant="contained"
                fullWidth
                startIcon={<SearchTwoToneIcon />}
                onClick={onClickSearch}
              >
                ค้นหา
              </Button>
            </Grid>
          </Grid>
          <Divider />
          <Tabs
            value={valueTab}
            onChange={handleChangeTab}
            aria-label="Tabs status"
          >
            <Tab value={null} label={"ทั้งหมด"} />
            {userGroup.result.map((opt, i) => (
              <Tab key={i} value={opt.id} label={opt.group_name} />
            ))}
          </Tabs>
          <Divider sx={{ mb: 2 }} />
          <DataTable columns={columns} rows={rows} />
        </Paper>
        <Dialog
          open={open}
          fullWidth
          maxWidth={"md"}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          component={"form"}
          onSubmit={formik.handleSubmit}
        >
          <DialogTitle id="alert-dialog-title">
            {formik.values.id ? "แก้ไข" : "เพิ่ม"}ผู้ใช้งาน
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              direction={"row"}
              justifyContent={"flex-start"}
              spacing={2}
            >
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  ข้อมูล
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="nameprefix"
                  name="nameprefix"
                  value={formik.values.nameprefix}
                  label="คำนำหน้า"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.nameprefix)}
                  helperText={formik.errors.nameprefix}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="fname"
                  name="fname"
                  value={formik.values.fname}
                  label="ชื่อ"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.fname)}
                  helperText={formik.errors.fname}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="lname"
                  name="lname"
                  value={formik.values.lname}
                  label="นามสกุล"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.lname)}
                  helperText={formik.errors.lname}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="idcard"
                  name="idcard"
                  value={formik.values.idcard}
                  label="เลขบัตรประชาชน"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.idcard)}
                  helperText={formik.errors.idcard}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="phone"
                  name="phone"
                  value={formik.values.phone}
                  label="เบอร์ติดต่อ"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  value={formik.values.email}
                  label="E-Mail"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  ที่อยู่
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="addrpart"
                  name="addrpart"
                  value={formik.values.addrpart}
                  label="ที่อยู่"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="tmbpart"
                  name="tmbpart"
                  value={formik.values.tmbpart}
                  label="แขวง/ตำบล"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="amppart"
                  name="amppart"
                  value={formik.values.amppart}
                  label="เขต/อำเภอ"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="chwpart"
                  name="chwpart"
                  value={formik.values.chwpart}
                  label="จังหวัด"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  id="zipcode"
                  name="zipcode"
                  value={formik.values.zipcode}
                  label="เลขไปรษณี"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                  สิทธิ์การใช้งาน
                </Typography>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl
                  fullWidth
                  size="small"
                  error={Boolean(formik.errors.group_id)}
                >
                  <InputLabel id="group_id-label">กลุ่มผู้ใช้งาน</InputLabel>
                  <Select
                    labelId="group_id-label"
                    id="group_id"
                    value={formik.values.group_id}
                    label="กลุ่มผู้ใช้งาน"
                    onChange={(e) => {
                      formik.setFieldValue("group_id", e.target.value);
                    }}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    {userGroup.result.map((opt, i) => (
                      <MenuItem key={i} value={opt.id}>
                        {opt.group_name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{formik.errors.group_id}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel id="visit_department_detail_name-label">
                    จุดตรวจ
                  </InputLabel>
                  <Select
                    labelId="visit_department_detail_name-label"
                    id="visit_department_detail_name"
                    value={formik.values.visit_department_detail_name}
                    label="จุดที่สั่ง"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "visit_department_detail_name",
                        e.target.value
                      );
                    }}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    {Array.isArray(visitDepartmentName) &&
                      visitDepartmentName.map((opt, i) => (
                        <MenuItem key={i} value={opt.visit_department_detail_name}>
                          {opt.visit_department_detail_name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControl fullWidth size="small">
                  <InputLabel id="department_detail_id-label">
                    จุดที่สั่ง
                  </InputLabel>
                  <Select
                    labelId="department_detail_id-label"
                    id="department_detail_id"
                    value={formik.values.department_detail_id}
                    label="จุดตรวจ"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "department_detail_id",
                        e.target.value
                      );
                    }}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    {departmentDetail.result.map((opt, i) => (
                      <MenuItem key={i} value={opt.department_detail_id}>
                        {opt.department_detail_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="permission_patient_type-label">
                    ประเภท
                  </InputLabel>
                  <Select
                    labelId="permission_patient_type-label"
                    id="permission_patient_type"
                    value={formik.values.permission_patient_type}
                    label="ประเภท"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "permission_patient_type",
                        e.target.value
                      );
                    }}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    <MenuItem value={"IPD"}>IPD</MenuItem>
                    <MenuItem value={"OPD"}>OPD</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth size="small">
                  <InputLabel id="lab_form_id-label">จุดส่งต่อ</InputLabel>
                  <Select
                    labelId="lab_form_id-label"
                    id="lab_form_id"
                    value={formik.values.lab_form_id}
                    label="จุดส่งต่อ"
                    onChange={(e) => {
                      formik.setFieldValue("lab_form_id", e.target.value);
                    }}
                  >
                    <MenuItem value={""}>ทั้งหมด</MenuItem>
                    {labForm.result.map((opt, i) => (
                      <MenuItem key={i} value={opt.lab_form_id}>
                        {opt.lab_form_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  id="password"
                  name="password"
                  type="password"
                  value={formik.values.password}
                  label="รหัสผ่าน"
                  size="small"
                  variant="outlined"
                  onChange={formik.handleChange}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={handleClose}
              color="error"
              startIcon={<CloseIcon />}
            >
              ปิด
            </Button>
            <Button
              variant="contained"
              type="submit"
              autoFocus
              startIcon={<SaveAltIcon />}
            >
              {formik.values.id ? "อัพเดท" : "บันทึก"}
            </Button>
          </DialogActions>
        </Dialog>
      </ContentPage>
    </Container>
  );
}
